import React, { FC, useContext, useEffect, useState } from "react";
import cn from "clsx";
import { Scrollbars } from "react-custom-scrollbars";
import FilterOptionItem from "./filterOptionItem";
import useSingleSelectFilter from "../hooks/useSingleSelectFilter";
import { SelectedFiltersContext } from "../webFilteringSection";
import useSelectedByResponse from "../hooks/useSelectedByResponse";
import FilterElement from "./filterElement";
import { DynamicYieldEventService } from "@/services";
import { GeneralFacet, SingleSelectFacet } from "../types";

type FilterSingleSelectProps = {
  filter: Omit<GeneralFacet & SingleSelectFacet, "sortOrder">;
  withDefaultSelection?: boolean;
};

const FilterSingleSelectWeb: FC<FilterSingleSelectProps> = ({
  filter,
  withDefaultSelection = true
}) => {
  const { onSelection, updateSelectedFilters } = useContext(
    SelectedFiltersContext
  );
  const [forceRerenderKey, setForceRerenderKey] = useState(false);
  const {
    filterOptions,
    selectedOption,
    onFilterOptionClick,
    setSelectedOption
  } = useSingleSelectFilter(filter, onSelection);
  const selectedByResponse = useSelectedByResponse(filterOptions)[0];

  useEffect(() => {
    if (selectedByResponse) {
      updateSelectedFilters({
        type: filter.type,
        label: filter.label,
        defaultLabel: filter.defaultLabel,
        queryParam: filter.queryParam,
        selectedOptions: [selectedByResponse]
      });
    }
  }, []);

  useEffect(() => {
    setSelectedOption(selectedByResponse);
  }, [filter, selectedByResponse, setSelectedOption]);

  const handleSelection = option => {
    if (filter.queryParam === "sort") {
      DynamicYieldEventService.sort(option);
    }
    onFilterOptionClick({ option }, event);
    setForceRerenderKey(!forceRerenderKey);
  };

  return (
    <>
      <FilterElement
        className={cn({
          items_selected: !!selectedOption
        })}
        filterLabel={filter.label}
        filterWrapperClassName="mxw-300"
        key={`${forceRerenderKey}`}
      >
        <Scrollbars autoHeight autoHeightMin={55} autoHeightMax={240}>
          <div>
            <ul className={cn("hierarchical_categories2_item")}>
              {filterOptions.map((option, index) => (
                <FilterOptionItem
                  key={option.key}
                  option={option}
                  isSelected={
                    option.isSelected ||
                    (!selectedOption && withDefaultSelection && index === 0)
                  }
                  onSelection={() => handleSelection(option)}
                />
              ))}
            </ul>
          </div>
        </Scrollbars>
      </FilterElement>
    </>
  );
};

export default FilterSingleSelectWeb;
